(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
   * Announcement-bar apps inject their own `position: sticky; top: 0` bar above
   * the header, with a z-index above it. Left alone, the header pins to 0 as
   * well and its top edge disappears behind that bar as soon as the page is
   * scrolled, so the header's sticky offset has to account for whatever is
   * pinned above it. Anything not sticky-at-top (fixed drawers, overlays) is
   * ignored.
   */
  function syncStickyOffset() {
    const section = document.querySelector('.section-header');
    if (!section) return;

    let offset = 0;
    for (const sibling of document.body.children) {
      if (sibling === section) break;
      const styles = window.getComputedStyle(sibling);
      if (styles.position === 'sticky' && styles.top === '0px') {
        offset += sibling.getBoundingClientRect().height;
      }
    }

    document.documentElement.style.setProperty('--header-sticky-offset', `${Math.round(offset)}px`);
  }

  /*
   * Homepage hero overlay: the header sits over the first section showing the
   * logo only, and turns into the full solid header as soon as the page moves.
   * The threshold is small on purpose so the two states never look half applied.
   */
  function initHeroOverlayHeader() {
    const header = document.querySelector('.header[data-hero-overlay]');
    if (!header) return;

    const section = header.closest('.section-header');
    if (!section) return;

    const SOLID_FROM = 24;
    let isSolid = null;
    let queued = false;

    const apply = () => {
      queued = false;
      const solid = (window.pageYOffset || document.documentElement.scrollTop) > SOLID_FROM;
      if (solid === isSolid) return;
      isSolid = solid;
      section.classList.toggle('header-solid', solid);
    };

    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    };

    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  document.addEventListener("DOMContentLoaded", (event) => {
    initHeroOverlayHeader();
    syncStickyOffset();

    /* The bar is usually moved to the top of the body after this point, and its
       height changes with the viewport, so keep the offset in step. */
    const bodyObserver = new MutationObserver(syncStickyOffset);
    bodyObserver.observe(document.body, { childList: true });
    window.addEventListener('load', () => {
      syncStickyOffset();
      setTimeout(() => bodyObserver.disconnect(), 3000);
    });
    window.addEventListener('resize', syncStickyOffset);

    const storeLoginBtn = document.querySelector(".trigger_btn");
    if (storeLoginBtn) {
      storeLoginBtn.addEventListener("click", (evt)=>{
        evt.preventDefault();
        if(document.querySelector(".header__icon--account")){
          document.querySelector(".header__icon--account").click();
        }
      });
    }

    const mobileSearchToggle = document.querySelector(".header-icon-search-mobile");
    if (mobileSearchToggle) {
      mobileSearchToggle.addEventListener("click", ()=>{
        const details = document.querySelector(".header__search details");
        if (!details) return;
        if(details.hasAttribute("open")){
          details.removeAttribute("open")
        }else{
          details.setAttribute("open","true")
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
